module.exports = __webpack_public_path__ + "static/media/instagram-circle.823015be.svg";